var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_2095)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_113_2095)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_113_2095)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_113_2095",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4483 0.551758H0.551758V31.4483H31.4483V0.551758Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_113_2095)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4483 15.9996C31.4483 24.5313 24.5331 31.4483 16 31.4483C7.46782 31.4483 0.551758 24.5313 0.551758 15.9996C0.551758 7.4683 7.46785 0.551758 16 0.551758C24.5331 0.551758 31.4483 7.4683 31.4483 15.9996ZM8.66527 22.4609H11.6767V12.8244H8.66527V22.4609ZM10.0721 11.619H10.0938C11.2256 11.619 11.9308 10.88 11.9308 9.94649C11.909 8.9956 11.2256 8.27585 10.1151 8.27585C9.00369 8.27585 8.27585 8.99743 8.27585 9.94914C8.27585 10.8823 8.98244 11.619 10.0721 11.619ZM20.3097 22.4609H23.7241V17.1025C23.7241 14.1181 22.0428 12.7317 19.9034 12.7317C18.1777 12.7317 17.0972 13.6755 16.8972 14.3367V12.8244H13.5146C13.5585 13.6275 13.5146 22.4608 13.5146 22.4608H16.8972V17.2466C16.8972 17.2125 16.897 17.1783 16.8968 17.1443C16.8955 16.8892 16.8942 16.6421 16.9708 16.459C17.2037 15.8792 17.7027 15.2783 18.6012 15.2783C19.776 15.2783 20.3097 16.169 20.3097 17.4741V22.4609Z",
    fill: "#1284C7"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_2095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_113_2095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_113_2095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.8966,
    fill: "white",
    transform: "translate(0 0.551758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f1853df35f8d4a1a7bf996bfcf2322ec.svg";
export { ForwardRef as ReactComponent };